import React, { useEffect, useState } from "react";
import {
  FaUpload,
  FaFolderOpen,
  FaDatabase,
  FaSignOutAlt,
  FaRobot,
} from "react-icons/fa";
import { useAuth } from "react-oidc-context";
import "../styles/Sidebar.css";
import { signOutRedirect } from "../CognitoConfig";

const Sidebar = ({ setView }) => {
  const auth = useAuth();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ estado para burger/drawer
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!auth.user) {
      setLoading(false);
      return;
    }
    const userGroups = auth.user.profile["cognito:groups"] || [];
    setGroups(userGroups);
    setLoading(false);
  }, [auth]);

  if (loading) return <div>Cargando permisos...</div>;

  // helper para navegar y cerrar drawer en mobile
  const go = (viewKey) => {
    setView(viewKey);
    setOpen(false);
  };

  return (
    <>
      {/* ✅ Burger button (solo visible en mobile por CSS) */}
      <button
        className="burger-btn"
        onClick={() => setOpen((v) => !v)}
        aria-label="Abrir menú"
      >
        ☰
      </button>

      {/* ✅ Overlay para cerrar al tocar fuera */}
      <div
        className={`sidebar-overlay ${open ? "show" : ""}`}
        onClick={() => setOpen(false)}
      />

      <div className={`sidebar ${open ? "open" : ""}`}>
        {/* ✅ Header con logo alineado a Topbar */}
        <div className="sidebar-header">
          <div className="sidebar-brand">OCESA</div>
        </div>

        <ul className="sidebar-list">
          {(groups.includes("admin") || groups.includes("uploaders")) && (
            <li>
              <button
                className="sidebar-button"
                onClick={() => go("upload")}
              >
                <FaUpload className="sidebar-icon" /> Subir Archivos
              </button>
            </li>
          )}

          {(groups.includes("admin") || groups.includes("viewers")) && (
            <li>
              <button
                className="sidebar-button"
                onClick={() => go("FileExplorer")}
              >
                <FaFolderOpen className="sidebar-icon" /> Visualizar Archivos
              </button>
            </li>
          )}

          {(groups.includes("admin") || groups.includes("governance")) && (
            <li>
              <button
                className="sidebar-button"
                onClick={() => go("data")}
              >
                <FaDatabase className="sidebar-icon" /> Datos
              </button>
            </li>
          )}

          <li>
            <button
              className="sidebar-button"
              onClick={() => go("chatInterface")}
            >
              <FaRobot className="sidebar-icon" /> Backstage AI
            </button>
          </li>

          <li className="sidebar-footer">
            <button
              className="sidebar-button logout-button"
              onClick={() => {
                setOpen(false);
                auth.removeUser();
                signOutRedirect();
              }}
            >
              <FaSignOutAlt className="sidebar-icon" /> Cerrar Sesión
            </button>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
